import { render, staticRenderFns } from "./DetailsView.vue?vue&type=template&id=189de8e7&scoped=true&"
import script from "./DetailsView.vue?vue&type=script&lang=js&"
export * from "./DetailsView.vue?vue&type=script&lang=js&"
import style0 from "./DetailsView.vue?vue&type=style&index=0&id=189de8e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189de8e7",
  null
  
)

export default component.exports